import React, { useState } from 'react';
import BaseCard from '../../components/base/BaseCard';
import StocksMetricsCard from './components/StocksMetricsCard';
import ExtrapolationMatrix from '../calculator/components/matrix/ExtrapolationMatrix';
import StocksSettingsModal from './components/StocksSettingsModal';
import StocksHeader from './components/StocksHeader';
import { useStocksCalculator } from './hooks/useStocksCalculator.ts';
import { useViewMode } from '../../hooks/useViewMode';

const StocksCalculator = () => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [focusField, setFocusField] = useState(null);
  const [viewMode, setViewMode] = useViewMode();
  const {
    values,
    setValues,
    metrics,
    validationErrors = {},
    isCalculating = false,
    extremePriceField
  } = useStocksCalculator();

  const handleOpenSettings = (field = null) => {
    setFocusField(field);
    setModalIsOpen(true);
  };

  return (
    <div className="flex justify-center pt-0 px-3 sm:px-6 pb-6">
      <div className="w-full max-w-5xl space-y-4">
        <BaseCard>
          <StocksHeader
            values={values}
            setValues={setValues}
            onOpenSettings={handleOpenSettings}
            errors={validationErrors}
            isCalculating={isCalculating}
            extremePriceField={extremePriceField}
          />
        </BaseCard>

        <StocksMetricsCard
          metrics={metrics}
          values={values}
          isLoading={isCalculating}
          viewMode={viewMode}
        />

        <ExtrapolationMatrix
          positionType={metrics.positionType}
          nominalRR={values.nominalRR}
          effectiveRR={values.nominalRR}
          risk={values.risk}
          accountBalance={values.accountBalance}
          disabled={isCalculating || Object.keys(validationErrors).length > 0}
        />

        <StocksSettingsModal
          isOpen={modalIsOpen}
          onClose={() => {
            setModalIsOpen(false);
            setFocusField(null);
          }}
          values={values}
          setValues={setValues}
          errors={validationErrors}
          initialFocusField={focusField}
          viewMode={viewMode}
          onViewModeChange={setViewMode}
          metrics={metrics}
        />
      </div>
    </div>
  );
};

export default StocksCalculator;
